/* eslint-disable @typescript-eslint/no-explicit-any */
import { configureStore } from '@reduxjs/toolkit';
import createCompressor from 'redux-persist-transform-compress';
import storage from 'redux-persist/lib/storage';
import type { AnyAction, Reducer } from 'redux';
import { migrateState, MigrateStateType } from '../../helper/migrate_state';
import { type PersistedState, persistReducer, persistStore } from 'redux-persist';
import rootReducer, { RootStateType } from './combined_reducers';

export type RootState = RootStateType;

// Creates a compressor to reduce the size of the persisted Redux state
const compress = createCompressor<RootStateType, RootStateType>() as any;

// const encryptor = createEncryptor({
//     secretKey: process.env.REACT_APP_SECRET_KEY,
//     onError: (error) => console.error('Encryption error:', error)
// });

// const transforms: Transform<RootStateType, RootStateType>[] = [
//     compress,
//     encryptor
// ];

// Configuration for redux-persist, specifying storage and settings

const persistConfig = {
    // Key for the root of the persisted state
    key: 'gonzy',
    version: 2,
    // Defines storage engine (localStorage in this case)
    // storage: storageSession,
    storage,
    // Prevents certain reducers from being persisted
    blacklist: ['navigation'],
    // whitelist: ['app', 'form', 'lead'],
    // Applies compression to reduce storage size
    transforms: [compress],
    migrate: async (state: PersistedState) => {
        const migrated = await migrateState(state as MigrateStateType);
        if (migrated && typeof migrated === 'object' && '_persist' in migrated) {
            return migrated as PersistedState;
        }
        // If migrateState does not return _persist, fallback to an empty persisted state
        return {
            _persist: {
                version: persistConfig.version,
                rehydrated: false
            }
        } as PersistedState;
    }
};

const typedRootReducer = rootReducer as Reducer<RootState, AnyAction>;

// Wraps the root reducer with persistence capabilities
const persistedReducer = persistReducer<RootState, AnyAction>(persistConfig, typedRootReducer);

// Configures the Redux store with the persisted reducer and default middleware
const store = configureStore({
    // reducer: process.env.REACT_APP_MODE === 'prod' ? rootReducer : persistedReducer as unknown as typeof rootReducer,
    reducer: persistedReducer,
    devTools: process.env.REACT_APP_MODE !== 'prod',
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: {
            // Ignores certain actions during serialization checks
            ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            // Excludes paths in actions to avoid serialization errors
            ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
            // Excludes specific paths in the state from serialization checks
            ignoredPaths: ['register'],
            immutableCheck: false
        }
    })
});

// Creates a persistor to handle rehydration of the persisted state
export type AppDispatch = typeof store.dispatch;
// export type RootState = ReturnType<typeof store.getState>;
export const persistor = persistStore(store, null, () => {
    const state = store.getState();
    if ('google' in state) {
        store.dispatch({ type: 'RESET_STATE' });
    }
});
export default store;
